export const ExperimentNames = {
    UseWarmupState: 'specs.events.ui.UseWarmupState',
    EditTicketPDF: 'specs.events.ui.EditTicketPDF',
    PageInstallFlow: 'specs.events.ui.PageInstallFlow',
    PublishedListTips: 'specs.events.PublishedListTips',
    NewBannerLayout: 'specs.events.BMBannerLayout',
    PreloadSeatingSummary: 'specs.events.ui.PreloadSeatingSummary',
    PricingPlansEventsFlexiForm: 'specs.events.ui.PricingPlansEventsFlexiForm',
    NotificationV2: 'specs.events.ui.NotificationV2',
    WixStudioDemoEvents: 'specs.events.ui.WixStudioDemoEvents',
    EventDetailsSlots: 'specs.events.ui.EventDetailsSlots',
    TicketPickerRedesign: 'specs.events.ui.TicketPickerRedesign',
    MessagesNewDesign: 'specs.events.ui.MessagesNewDesign',
    RsvpDynamicMessages: 'specs.events.ui.RsvpDynamicMessages',
    RicosBusinessManager: 'specs.events.ui.Ricos',
    DetailsNoRegistration: 'specs.events.ui.DetailsNoRegistration',
    PapyrusThankYouPageFlow: 'specs.events.ui.PapyrusThankYouPageFlow',
    CheckoutTimeLimit: 'specs.events.ui.EditableCheckoutTimeLimit',
    StaffPage: 'specs.events.ui.Staff',
    ZeroPricingOption: 'specs.events.ui.ZeroPricingOption',
    ZeroInsteadOfFree: 'specs.events.ui.ZeroInsteadOfFree',
    ListLayoutDateStyle: 'specs.events.ui.ListLayoutDateStyle',
    DateAndLocationSettings: 'specs.events.ui.DateLocationSettings',
    TempFixRecurringEvents: 'specs.events.TempFixRecurringEvents',
    SeatingsUiProperties: 'specs.seatings.ui.UiPropertiesMigrationViewer',
    SausageIntegration: 'specs.events.ui.SausageIntegration',
    ReuseTicketsDesign: 'specs.events.ui.ReuseTicketsDesign',
    DateTimeImprovements: 'specs.events.ui.DateTimeImprovements',
    GuestListTicketTypeFilter: 'specs.events.ui.GuestListTicketTypeFilter',
    LinksColorSetting: 'specs.events.ui.LinksColorSetting',
    SeatingIntegrationApiV2: 'specs.seatings.ui.IntegrationApiV2',
};
//# sourceMappingURL=experiments.js.map